(() => {
  const initHeader = (root = document) => {
    root.querySelectorAll('[data-trc-header]').forEach((header) => {
      if (header.dataset.trcInitialized === 'true') return;
      header.dataset.trcInitialized = 'true';

      const toggle = header.querySelector('[data-trc-menu-toggle]');
      const menu = header.querySelector('[data-trc-mobile-menu]');
      if (!toggle || !menu) return;

      const closeMenu = () => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
      };

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        menu.classList.toggle('is-open', !isOpen);
      });

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMenu);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu();
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) closeMenu();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeader());
  } else {
    initHeader();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHeader(event.target);
  });
})();
